import { render, staticRenderFns } from "./plans-modal.vue?vue&type=template&id=9858fae4&"
import script from "./plans-modal.vue?vue&type=script&lang=js&"
export * from "./plans-modal.vue?vue&type=script&lang=js&"
import style0 from "./plans-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports